import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const cols = [
  {
    title: "Sections",
    items: [
      ["Manifesto", "#manifesto"],
      ["Top Shelf", "#top-shelf"],
      ["Journal", "#journal"],
    ],
  },
  {
    title: "House",
    items: [
      ["The Editors", "#"],
      ["Contribute", "#"],
      ["Affiliate Notice", "#"],
      ["Contact", "#"],
    ],
  },
  {
    title: "Elsewhere",
    items: [
      ["Instagram", "#"],
      ["Substack", "#"],
    ],
  },
];

export default function Footer() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end end"] });
  const y = useTransform(scrollYProgress, [0, 1], [80, 0]);

  return (
    <footer
      ref={ref}
      data-testid="footer"
      className="relative pt-24 pb-10 border-t"
      style={{ borderColor: "var(--hairline)", background: "var(--bg)" }}
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-8 pb-16">
          <div className="col-span-12 lg:col-span-6">
            <div className="eyebrow mb-4">Volume IV · MMXXV</div>
            <p className="font-display text-lg italic max-w-md text-bone-dim">
              A dark house for whiskey, spirits, and the quieter pleasures.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title} className="col-span-6 lg:col-span-2">
              <div className="eyebrow mb-6">{c.title}</div>
              <ul className="flex flex-col gap-3">
                {c.items.map(([label, href]) => (
                  <li key={label}>
                    <a
                      href={href}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="font-body text-lg text-bone hover:text-[var(--amber)] transition-colors"
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <motion.div style={{ y }} className="relative pt-6">
          <div
            aria-hidden
            className="font-display text-[22vw] leading-[0.8] tracking-tighter text-bone/95 whitespace-nowrap select-none"
            style={{ letterSpacing: "-0.04em" }}
          >
            Johnny <em className="italic font-light" style={{ color: "var(--amber)" }}>Dram.</em>
          </div>
        </motion.div>

        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t pt-6" style={{ borderColor: "var(--hairline)" }}>
          <div className="eyebrow" style={{ color: "var(--bone-dim)" }}>
            © MMXXV · Johnny Dram · Please drink responsibly, 21+
          </div>
          <div className="eyebrow" style={{ color: "var(--bone-dim)" }}>
            As an Amazon Associate we earn from qualifying drams.
          </div>
        </div>
      </div>
    </footer>
  );
}
